import * as Popover from '@radix-ui/react-popover';
import { Bell } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAcknowledgeAllAlarms, useAlarms } from '../../../hooks/useAlarms';
import { AlarmFeedList } from '../../ui/AlarmFeedList';

/** Bell icon in the topbar — opens a preview of the four most recent alarms. */
export function NotificationBellMenu() {
  const { data: alarms } = useAlarms(); 
  const ackAll = useAcknowledgeAllAlarms();
  const navigate = useNavigate();

  const unreadCount = alarms?.filter((a) => !a.acknowledged).length ?? 0;
  const preview = alarms?.slice(0, 4) ?? [];

  return (
    <Popover.Root>
      <Popover.Trigger asChild>
        <button
          type="button"
          aria-label="notifications"
          className="relative flex h-9 w-9 items-center justify-center rounded-full text-text-secondary hover:bg-surface-hover"
        >
          <Bell size={18} />
          {unreadCount > 0 && (
            <span className="absolute right-1 top-1 flex h-4 min-w-4 items-center justify-center rounded-full bg-error px-1 text-[10px] font-bold text-white">
              {unreadCount}
            </span>
          )}
        </button>
      </Popover.Trigger>
      <Popover.Portal>
        <Popover.Content
          align="end"
          sideOffset={8}
          className="z-50 w-[360px] rounded-2xl border border-border bg-surface shadow-xl outline-none"
        >
          <div className="flex items-center justify-between border-b border-border px-4 py-3">
            <p className="text-sm font-bold text-text-primary">Notifications</p>
            <Popover.Close asChild>
              <button type="button" onClick={() => navigate('/notifications')} className="text-sm font-semibold text-primary">
                View all
              </button>
            </Popover.Close>
          </div>
          <div className="max-h-[340px] overflow-y-auto px-4">
            <AlarmFeedList alarms={preview} />
          </div>
          <div className="border-t border-border py-2 text-center">
            <button type="button" onClick={() => ackAll.mutate()} className="text-sm font-semibold text-primary">
              Mark all as read
            </button>
          </div>
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
}
